import * as React from 'react';
import { Button as FlowBiteButton, ButtonProps as FlowBiteButtonProps } from 'flowbite-react';
import { ButtonColorsEnum, ButtonSizesEnum, buttonIconTheme } from '../../styles/themes/button';

export type ButtonIconProps = Omit<FlowBiteButtonProps, 'label' | 'size' | 'color'> & {
    size: ButtonSizesEnum;
    color: ButtonColorsEnum;
    ariaLabel?: string;
    testId?: string;
};

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonIconProps>(
    ({ children, size, color, ariaLabel, testId, ...otherProps }, ref) => {
        return (
            <FlowBiteButton
                ref={ref}
                pill
                size={size}
                color={color}
                aria-label={ariaLabel}
                data-testid={testId}
                theme={buttonIconTheme}
                {...otherProps}
            >
                {children}
            </FlowBiteButton>
        );
    },
);

ButtonIcon.displayName = 'ButtonIcon';
